<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-account-multiple</v-icon> Users  <v-divider vertical inset class="ml-5 mr-2"/>
                     <v-btn text small color="success"  @click="user={}, state='new', form=true">
                      <v-icon small left color="success">mdi-plus</v-icon>Add 
                    </v-btn>
                    <v-spacer/>
                    <span style="width: 290px;">
                           <v-text-field
                               v-model="search"
                               append-icon="mdi-magnify"
                               label="Search"
                               single-line
                               dense
                               outlined
                               hide-details
                           ></v-text-field>
                    </span>
                  
                  </v-toolbar>
                  <v-card-text  v-if="items.length">
                  <table class="va-table va-table-border-bot">
                     <tr>
                       <th width="50"></th>
                       <th>ID</th>
                       <th>Username</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Registered</th>
                         <th>Last Login</th>
                        <th>Status</th>
                     </tr> 
                     <tr v-for="(item, index) in FILTEREDITEMS" :key="index">
                   
                          <td>
                            <v-badge
                                            avatar
                                            bordered
                                            bottom
                                            overlap
                                            :id="'menu-activator-ck-'+index" 
                                          >
                                            <template v-slot:badge>
                                              <v-avatar color="white">
                                               <v-icon class="va_hover"  small  color="#858585">mdi-text-box-edit</v-icon>
                                              </v-avatar>
                                             
                                            </template>

                                            <v-avatar size="40" >
                                              <img v-if="item.profile!=null" :src="item.profile.picture">
                                              <img v-else :src="$store.state.imgholder" />
                                           
                                            </v-avatar>
                                          </v-badge>
                                           <v-menu :activator="'#menu-activator-ck-'+index" offset-y>
                                                <div style="width: 150px">
                                                  <v-btn color="#fff" tile elevation="0" block small @click="user=item,state='modify',form=true">Details</v-btn>
                                                  <v-btn color="#fff" tile elevation="0" block small @click="user=item, transaction=true">Activities</v-btn>
                                               </div>
                                              </v-menu>
                            </td>
                            <td>{{ item.id }}</td>
                            <td>{{ item.username }}</td>
                            <td>{{ item.fullname }}</td>
                            <td>{{ item.role }}</td>
                             <td>{{ $moment(item.created).fromNow()}}</td>
                            <td><v-icon left small :color="statusIndicator(item.last_login)">mdi-checkbox-blank-circle</v-icon> 
                              <span v-if="item.last_login != null" class="font-italic def-font">{{ $moment(item.last_login).fromNow()}}</span> 
                              <span v-else class="font-italic def-font">Not yet login</span>
                            </td>
                            <td><v-chip  :class="STATUS_COLOR(item.status)" small>{{ item.status }}</v-chip></td>
                    </tr>
                  </table>
                 
                    <div class="pa-4">
                          <span class="mx-2">Item(s) Found: {{SEARCHFILTER.length}}</span>|
                          <span class="mx-2">
                            Rows per page: <select v-model="view.per_page" @change="view.current_page=1"  class="va-select">
                              <option v-for="fruit in [5,10,15,20,50,100,1000]" :key="fruit" :value="fruit">
                                {{ fruit }}
                              </option>
                            </select>
                          </span>
                          |
                            <span class="mx-2">
                            <v-icon left small @click="view.current_page>1?view.current_page=view.current_page-1:view.current_page=1">mdi-arrow-left</v-icon>
                            {{view.current_page}}/{{ PAGE_COUNT}}
                            <v-icon right small @click="view.current_page<PAGE_COUNT?view.current_page=view.current_page+1:view.current_page=PAGE_COUNT">mdi-arrow-right</v-icon>
                             </span>   
                    </div>
                     
                  </v-card-text>
                  <v-card-text class="text-center" v-else>
                          <div class="font-weight-thin font-italic pa-5 mt-5"  >
                            <a  @click="user={}, state='new', form=true">Add your first user...  <v-icon  right small color="primary">mdi-pencil</v-icon></a>
                          </div>
                    </v-card-text>
             
                </v-card>
             </v-col>
       </v-row>
       </v-container>
        <!-- <va-customer-form :show="form" :selectedID="customer.id" :state="state" @DialogEvent="formEvent" />
         <va-customer-transaction :show="transaction" :customer="customer" @ConfirmEvent="transaction=false" /> -->
         <va-user-form :show="form" :data="user" :state="state" @DialogEvent="formEvent" />
          
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           transaction: false,
           search:"",
           selectedID:  null,
           trans_dailog: false,
           areaform: false,
           state: 'new',
           user:{profile:{picture:""}},
           items:[],
           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           }
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         }
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
              this.CHECKPAGEPERMISSION()
             this.SETVARS()
             setTimeout(()=>{this.getItems()}, 500)
            
           }
       },
       computed:{
         FILTEREDITEMS(){
            if(this.items.length == 0) {
              return []
            }
            var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
            return pageArr[this.view.current_page - 1]
         },
         PAGE_COUNT(){
          var pageArr = this.$pagination(this.SEARCHFILTER,this.view.per_page)
          return pageArr.length
         },
         SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.items, this.search)
            } else {
              return this.items
            }
         }
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
        statusIndicator(_time) {
          //var current = this.$moment(_time)
          var a = this.$moment()
            var b = this.$moment(_time)
           var diff = a.diff(b, 'hour')
           if(diff <=  3) {
              return 'success'
           } else if(diff > 3 && diff < 5) {
               return '#A5D6A7'
           } else {
             return '#989898'
           }
      },
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
         formEvent(){
             this.form = false
             this.getItems()
         },
   
         getItems: function() { 
          this.VA_ALERT('info', 'Loading users data', 'progress', 100, 1500)
           this.items = []
            this.QUERY('vendors','select * from users order by id desc', (res)=>{
              console.log(res)
              if(res.status) {
                  this.items = res.results
              }
              
            })
        }
       }
     }
   </script>